import { ModalForm, ProFormText } from '@ant-design/pro-components';
import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import PropTypes from 'prop-types';
import { updateOrganization } from '../services/organizations';

const UpdateOrganizationForm = ({ reload, values }) => {
  const { message } = App.useApp();
  const { mutateAsync: update, isPending } = useMutation({
    mutationFn: updateOrganization,
    onSuccess: () => {
      message.success('租户信息已更新');
      reload?.();
    },
    onError: () => {
      message.error('租户信息更新失败，请重试');
    },
  });

  return (
    <ModalForm
      title="编辑租户"
      trigger={<Button type="link">编辑</Button>}
      width={480}
      initialValues={values}
      modalProps={{
        destroyOnHidden: true,
        okButtonProps: {
          loading: isPending,
        },
      }}
      onFinish={async (formValues) => {
        try {
          await update({
            data: formValues,
          });
          return true;
        } catch {
          return false;
        }
      }}
    >
      <ProFormText name="id" hidden />
      <ProFormText
        name="name"
        label="租户名称"
        rules={[
          {
            required: true,
            message: '请输入租户名称',
          },
        ]}
      />
      <ProFormText
        name="slug"
        label="租户标识"
        rules={[
          {
            required: true,
            message: '请输入租户标识',
          },
          {
            pattern: /^[a-z0-9-]+$/,
            message: '仅支持小写字母、数字和短横线',
          },
        ]}
      />
    </ModalForm>
  );
};

UpdateOrganizationForm.propTypes = {
  reload: PropTypes.func,
  values: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
};

export default UpdateOrganizationForm;
